import * as types from "./types";

const INITIAL_STATE = {
  reasons: [],
  item: [],
  meta: {},
};

const reason = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_REASON_RESPONSE:
      return {
        ...state,
        reasons: action.payload.reasons,
        meta: action.payload.meta,
      };
    case types.GET_SINGLE_REASON_RESPONSE:
      return {
        ...state,
        item: action.payload,
      };
    default:
      return state;
  }
};

export default reason;
